import { Component } from '@angular/core';
import player from 'lottie-web';
import { AnimationOptions, LottieDirective, provideLottieOptions } from 'ngx-lottie';

const LottieProvider = provideLottieOptions({ player: () => player });

@Component({
  selector: 'app-community-loader',
  template: `
    <div class="community-loader" lottie [options]="options"></div>
  `,
  styleUrls: ['./community-loader.component.scss'],
  imports: [LottieDirective],
  providers: [LottieProvider],
})
export class CommunityLoaderComponent {
  options: AnimationOptions = {
    path: 'assets/loaders/loader.json',
  };
}
